import { isArray } from "@/views/zhiji/js/common/util.js";
import platTextLink from "./platTextLink.js";
import form from "./form.js";
import hotRecommend from "./hotRecommend.js";
import tool from "./tool.js";
import hList from "./hList.js";
import picture from "./picture.js";
import giftPackage from "./package.js";
import video from "./video.js";
import guides from "./guides.js";

let widgetManager = {
    serverMap: {},
    clientMap: {},
    injectWidget(widget) {
        if (isArray(widget.serverType)) {
            widget.serverType.forEach(type => {
                this.serverMap[type] = widget;
            });
        } else {
            this.serverMap[widget.serverType] = widget;
        }

        this.clientMap[widget.widgetName] = widget;
    }
};

widgetManager.injectWidget(form);
widgetManager.injectWidget(platTextLink);
widgetManager.injectWidget(hotRecommend);
widgetManager.injectWidget(tool);
widgetManager.injectWidget(hList);
widgetManager.injectWidget(picture);
widgetManager.injectWidget(giftPackage);
widgetManager.injectWidget(video);
widgetManager.injectWidget(guides);

export default widgetManager;
